import React from 'react'
import "./TrendingProducts.css"
import { Col, Container, Row } from 'react-bootstrap'
const TrendingProducts = () => {
  return (
   <>
        <section id="trending_products">
            <Container>
                <Row style={{justifyContent : 'space-evenly', rowGap : '20px'}}>
                   <Col  xs={6} lg={2} sm={3} md={3}>
                        <div class="trending_inner ">
                            <div className='trending_inner-img'>
                                <img src="./imeges/discount icon.svg" alt=""/>
                            </div>
                            <p class="trn-text">Discount</p>
                            <p class="trn-per">Every week new sales</p>
                        </div>
                    </Col>
                   <Col xs={6} lg={2} sm={3} md={3}>
                        <div class="trending_inner  ">
                            <div className='trending_inner-img'>
                                <img src="./imeges/seport icon.svg" alt=""/>
                            </div>
                            <p class="trn-text">sepport 24/7</p>
                            <p class="trn-per">Dedicated support</p>
                        </div>
                    </Col>
                   <Col xs={6} lg={2} sm={3} md={3}>
                        <div class="trending_inner ">
                            <div className='trending_inner-img'>
                                <img src="./imeges/free delivery icon.svg" alt=""/>
                            </div>
                            <p class="trn-text">Free Delivery</p>
                            <p class="trn-per">For all orders over $99</p>
                        </div>
                    </Col>
                   <Col xs={6} lg={2} sm={3} md={3}>
                        <div class="trending_inner  ">
                            <div className='trending_inner-img'>
                             <img src="./imeges/credit card icon.svg" alt=""/>
                            </div>
                            <p class="trn-text">Secure Payment</p>
                            <p class="trn-per">100% Secure payment</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
   </>
  )
}

export default TrendingProducts